module.exports = __webpack_public_path__ + "static/media/tuna.e2bfcaae.svg";